import { useState } from 'react'

import { albumByIdQuery } from '@/entities/albums'
import { type AuthorPreview } from '@/entities/authors'
import { StretchedTabs } from '@/shared/ui'
import { RoundedTabLabel } from '@/shared/ui'
import {
  CheckOutlined,
  PushpinOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons'
import { useUnit } from 'effector-react'
import { useLocation } from 'react-router-dom'

import { AlbumFormCommonInformation } from './ui/AlbumFormCommonInformation'
import { AlbumFormTracks } from './ui/AlbumFormTracks'

export {
  lastCreatedAlbumIdReset,
  $lastCreatedAlbumId,
  $albumCommonInformationFormInitialAuthor,
} from './model/album-form-common-information.model'

export enum AlbumFormTabsKeys {
  CommonInformation = 'common_information',
  Tracks = 'tracks',
}

interface AlbumFormProps {
  onAuthorButtonClick: (callback: (id: string) => void) => void
  onTrackEditButtonClick?: (id: string) => void
}

export const AlbumForm = ({
  onAuthorButtonClick,
  onTrackEditButtonClick,
}: AlbumFormProps) => {
  const location = useLocation()
  const state = location.state as {
    activeTab?: AlbumFormTabsKeys
    author?: AuthorPreview
  }

  const [activeTabKey, setActiveTabKey] = useState(
    state?.activeTab ?? AlbumFormTabsKeys.CommonInformation,
  )

  const initialAuthor: AuthorPreview | undefined = state?.author

  const albumByIdQueryStatus = useUnit(albumByIdQuery.$status)
  const creating = albumByIdQueryStatus === 'initial'

  return (
    <StretchedTabs
      activeKey={activeTabKey}
      onChange={(key: string) => setActiveTabKey(key as AlbumFormTabsKeys)}
      items={[
        {
          key: AlbumFormTabsKeys.CommonInformation,
          label: (
            <RoundedTabLabel
              done={!creating}
              roundChildren={<UnorderedListOutlined />}
            >
              Общая информация
            </RoundedTabLabel>
          ),
          children: (
            <AlbumFormCommonInformation
              onAuthorButtonClick={onAuthorButtonClick}
              initialAuthor={initialAuthor}
            />
          ),
        },
        {
          key: AlbumFormTabsKeys.Tracks,
          disabled: creating,
          label: (
            <RoundedTabLabel
              roundChildren={<PushpinOutlined />}
              disabled={creating}
            >
              Треки
            </RoundedTabLabel>
          ),
          children: (
            <>
              {onTrackEditButtonClick && (
                <AlbumFormTracks
                  onTrackEditButtonClick={onTrackEditButtonClick}
                />
              )}
            </>
          ),
        },
      ]}
    />
  )
}
